<template>
  <form id="form-add-diseases" class="position-relative">
    <loader :loading="loadingForm" block />
    <div class="vuedl-layout__closeBtn" @click="close(true)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        {{ isUpdate ? "Диагноз" : "Добавить диагноз" }}
      </v-card-title>
      <v-card-text class="py-1">
        <v-tabs v-if="!editOnlyComment" fixed-tabs v-model="selectedTab">
          <v-tab>Диагноз</v-tab>
          <v-tab>Поиск заболевания по МКБ-10</v-tab>
        </v-tabs>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item>
            <v-card flat>
              <v-card-text class="py-1">
                <v-select
                  v-model="form.type_id"
                  :items="diseasesTypes"
                  item-text="name"
                  item-value="id"
                  label="Тип диагноза"
                  :error-messages="diseaseTypeIdErrors"
                  single-line
                  :readonly="editOnlyComment"
                ></v-select>
              </v-card-text>
              <v-card-text class="py-1">
                <v-autocomplete
                  label="Диагноз"
                  hide-no-data
                  hide-selected
                  v-model="form.disease"
                  item-text="name"
                  item-value="code"
                  return-object
                  :loading="loadingDiseases"
                  :items="diseasesList"
                  :error-messages="diseaseNameErrors"
                  :search-input.sync="searchDisease"
                  :readonly="editOnlyComment"
                >
                  <template v-slot:item="{ props, item }"> <span v-html="item.listName"></span> </template>
                </v-autocomplete>
              </v-card-text>

              <v-card-text class="py-1">
                <v-text-field
                  label="Код болезни"
                  readonly
                  disabled
                  :value="form.disease ? form.disease.code : ''"
                  :error-messages="diseaseCodeErrors"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item v-if="!editOnlyComment">
            <v-card flat>
              <v-card-text>
                <SearchMKB10 v-model="form.disease" @select="onSelectMKB10" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="py-1">
        <date-picker
          label="Дата начала"
          :hide-details="false"
          v-model="form.dateStart"
          :error-messages="dateStartErrors"
          @input="$v.form.dateStart.$touch()"
          @blur="$v.form.dateStart.$touch()"
          :readonly="editOnlyComment"
          :max="new Date().toISOString()"
        />

        <date-picker
          label="Дата окончания"
          :hide-details="false"
          v-model="form.dateEnd"
          :error-messages="dateEndErrors"
          @input="$v.form.dateEnd.$touch()"
          @blur="$v.form.dateEnd.$touch()"
          :readonly="editOnlyComment"
          :max="new Date().toISOString()"
        />
      </v-card-text>

      <v-card-text>
        <v-textarea outlined label="Примечание" v-model="form.details" />
      </v-card-text>

      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-btn id="form-add-diseases-cancel" color="primary" text @click="close(true)">Отменить</v-btn>
        <v-spacer></v-spacer>
        <v-btn id="form-add-diseases-submit" color="primary" text @click="submit">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import DatePicker from "@/components/forms/DatePicker";
// import throttle from 'lodash/throttle';
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper";
import SearchMKB10 from "@/components/SearchMKB10";
import Loader from "@/components/Loader";

// Дефолтное состояние формы
const formState = {
  disease: {
    id: "",
    code: "",
    name: "",
  }, // diseaseUserInput
  type_id: "",
  dateStart: "", // user_disease_strdate
  dateEnd: "", //user_disease_enddate
  details: "", //user_disease_details
};

export default {
  name: "AddDiseases",

  components: { Loader, SearchMKB10, DatePicker },

  props: {
    model: {
      type: Object,
    },
    editOnlyComment: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    loadingForm: false,
    selectedTab: 0,

    searchDisease: null,
    loadingDiseases: false,
    diseasesList: [],
    diseasesTypes: [],
    form: { ...formState },
  }),

  validations: {
    form: {
      disease: {
        name: { required },
        code: { required },
      },
      type_id: { required },
      dateStart: {},
      dateEnd: {},
      details: {},
    },
  },

  computed: {
    isUpdate() {
      return !!this.model;
    },

    diseaseNameErrors() {
      return messageHelper(this.$v.form.disease.name);
    },

    diseaseTypeIdErrors() {
      return messageHelper(this.$v.form.type_id);
    },

    diseaseCodeErrors() {
      return messageHelper(this.$v.form.disease.code);
    },

    dateStartErrors() {
      return messageHelper(this.$v.form.dateStart);
    },

    dateEndErrors() {
      return messageHelper(this.$v.form.dateEnd);
    },
  },

  watch: {
    // Посик по названию болезни
    searchDisease(value) {
      if (value) {
        value = value.split("(")[0];
      }
      // Items have already been requested
      if (this.loadingDiseases) return;

      if (this.form.disease && !value && value !== this.form.disease.name) {
        return;
      }

      this.$http
        .get(`v1/diseases`, { params: { search: value } })
        .then(response => {
          this.diseasesList = response.data.data.map(item => {
            item.listName = `${item.name} <span style='color:#757575'>${item.code}</span>`;
            item.name = `${item.name} (${item.code})`;
            return item;
          });
          this.loadingDiseases = false;
        })
        .catch(e => {
          console.error("Ошибка поиск по болезням", e.response.data.message);
          this.loadingDiseases = false;
        });
    },
  },

  created() {
    this.mapModelToForm();

    this.$http
      .get(`v1/diseases/types`)
      .then(response => {
        this.diseasesTypes = response.data.data;
        this.loadingDiseases = false;
      })
      .catch(e => {
        console.error("Ошибка загрузки типов заболеваний", e.response.data.message);
        this.loadingDiseases = false;
      });
  },

  mounted() {
    const parentModal = document.querySelector(".v-dialog.v-dialog--active");
    if (parentModal) {
      const observer = new MutationObserver(mutationRecords => {
        if (!parentModal.attributes.class.value.includes("active")) {
          this.selectedTab = 0;
          this.resetForm();
        }
      });
      observer.observe(parentModal, { attributes: true, attributeFilter: ["class"] });
    }
  },

  methods: {
    loading(val) {
      this.loadingForm = val;
      this.$emit("loading", val);
    },

    /**
     * Закрытия модального окна
     */
    close() {
      this.resetForm();
      this.$emit("close");
      this.$emit("submit", false);
    },

    /**
     * Сброс формы
     */
    resetForm() {
      this.$v.$reset();
      this.form = { ...formState };
    },

    /**
     * Отправка формы
     */
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      this.loading(true);

      const formData = {
        doctor_id: this.$store.state.auth.id,
        disease: {
          id: this.form.disease.id,
          code: this.form.disease.code,
          name: this.form.disease.name,
        },
        type_id: this.form.type_id,
        date: {
          start: this.form.dateStart,
          end: this.form.dateEnd,
        },
        details: this.form.details,
      };

      if (this.isUpdate) {
        await this._updateItem(formData);
      } else {
        await this._createItem(formData);
      }
    },

    async _createItem(formData) {
      try {
        const response = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/diseases`, formData);

        this.loading(false);
        this.$store.commit("diseases/ADD_ITEM", response.data.data);
        this.$store.commit("diseases/INCREASE_META_TOTAL");
        this.$notify.showMessage(response.data.message, "success");
        this.close();
      } catch (e) {
        this.loading(false);
        this.$notify.showMessage(e.response.message, "error");
      }
    },

    async _updateItem(formData) {
      try {
        const r = await this.$http.put(`v1/customers/${this.$store.state.customer.id}/diseases/${this.model.id}`, formData);

        this.loading(false);
        this.$store.commit("diseases/UPDATE_ITEM", this.getUpdatedModel());
        this.$notify.showMessage(r.data.message, "success");
        this.close();
      } catch (e) {
        this.loading(false);
        if (e.response) {
          this.$notify.showMessage(e.response.message, "error");
        }
      }
    },

    /**
     * Вызывает форму добавления нового лекарства
     */
    addNewMedicineName() {
      alert("Новое лекарство");
    },

    onSelectMKB10(item) {
      const res = Object.assign({}, item);
      res.listName = `${item.name} <span style='color:#757575'>${item.code}</span>`;
      res.name = `${item.name} (${item.code})`;
      this.diseasesList = [res];
      this.selectedTab = 0;
    },

    mapModelToForm() {
      if (this.isUpdate) {
        this.form = {
          disease: {
            id: this.model.icd10.id,
            code: this.model.icd10.code,
            name: this.model.icd10.translation.name,
          },
          type_id: this.model.type_id,
          dateStart: this.model.date_start,
          dateEnd: this.model.date_end,
          details: this.model.details,
        };
        this.diseasesList = [this.form.disease];
      }
    },

    getUpdatedModel() {
      /** @type {DiseasesItem} */
      const model = {
        ...this.model,
        date_start: this.form.dateStart,
        date_end: this.form.dateEnd,
        details: this.form.details,
      };

      model.icd10.id = this.form.disease.id;
      model.icd10.code = this.form.disease.code;
      model.icd10.translation.name = this.form.disease.name;

      return model;
    },
  },
};
</script>
